import { Container, Typography, Paper, Box } from "@mui/material";
import SeoHead from "../components/SeoHead";

const sections = [
  {
    title: "I. What Are Cookies",
    body: `Cookies are small text files that are stored on your device when you visit a website. They are widely used to make websites work more efficiently and to provide information to the website owners.`,
  },
  {
    title: "II. How We Use Cookies",
    body: `Music Brackets uses the following types of cookies:\n\n- Authentication Cookies: We use a session cookie to keep you signed in after logging in with Google. This cookie is essential for the sign-in feature to work.\n- Preference Cookies: We use localStorage to save your game state, settings (language, streamer mode), and game progress so you can continue where you left off.`,
  },
  {
    title: "III. Third-Party Cookies",
    body: `We use Google AdSense to display advertisements. Google may use cookies to serve ads based on your prior visits to this or other websites. Google's use of advertising cookies enables it and its partners to serve ads based on your visit to Music Brackets and/or other sites on the Internet.\n\nYou may opt out of personalized advertising by visiting Google's Ads Settings at https://www.google.com/settings/ads.`,
  },
  {
    title: "IV. Google Analytics",
    body: `We may use Google Analytics to understand how visitors interact with our website. Google Analytics uses cookies to collect information about your use of the site. This information is used to compile reports and help us improve the site.`,
  },
  {
    title: "V. Managing Cookies",
    body: `You can control and manage cookies in your browser settings. Here's how to manage cookies in common browsers:\n\n- Chrome: Settings > Privacy and Security > Cookies and other site data\n- Firefox: Settings > Privacy & Security > Cookies and Site Data\n- Safari: Preferences > Privacy > Manage Website Data\n- Edge: Settings > Cookies and site permissions > Cookies and site data\n\nPlease note that disabling cookies may affect the functionality of Music Brackets, particularly the sign-in and game save features.`,
  },
  {
    title: "VI. Changes to This Policy",
    body: `We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.`,
  },
  {
    title: "VII. Contact Us",
    body: `If you have any questions about our use of cookies, please contact us at support@musicrandomizer.com.`,
  },
];

export default function CookiePolicyPage() {
  return (
    <Container id="cookie-policy-page" maxWidth="md" sx={{ mt: 4 }}>
      <SeoHead
        title="Cookie Policy"
        description="Learn how Music Brackets uses cookies and how to manage them."
        canonical="/cookie-policy"
      />
      <Box id="cookie-policy-header" sx={{ textAlign: "center", mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Cookie Policy
        </Typography>
        <Typography variant="h6" color="text.secondary">
          <em>Last Updated: February 15, 2026</em>
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" paragraph>
          This Cookie Policy explains how Music Brackets uses cookies and similar
          technologies when you visit our website.
        </Typography>

        {sections.map((section, index) => (
          <Box key={index} sx={{ mt: index === 0 ? 3 : 2 }}>
            <Typography variant="h5" sx={{ mb: 1 }}>
              {section.title}
            </Typography>
            {section.body.split("\n\n").map((block, blockIdx) => (
              <Typography key={blockIdx} variant="body1" paragraph>
                {block.split("\n").map((line, lineIdx, arr) => (
                  <span key={lineIdx}>
                    {line}
                    {lineIdx < arr.length - 1 && <br />}
                  </span>
                ))}
              </Typography>
            ))}
          </Box>
        ))}
      </Paper>
    </Container>
  );
}
